import { useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
// import { bannerAddEdit } from "../../../../services/bannersService";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Textarea from "../../../form/Textarea";
import { toast } from "react-toastify";
import Editor from "../../../form/Editor";
import Select from "../../../form/select/Select";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useDebounce } from "../../../../hooks/useDebounce";
import { removeDuplicateFromArray } from "../../../../helpers";
import { pageAddEdit, pageList } from "../../../../services/pageService";
import { useSelector } from "react-redux";
import Tags from "../../../form/Tags";

const validation = {
  title: { required: true, message: "title is required" },
};

const ManagePage = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
  });

  const [pageFilters, setPageFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [pagekeyword, setPlankeyword] = useState("");
  const pageSearch = useDebounce(pagekeyword, 300);
  const { data: user } = useSelector((state) => state.profile);

  const { data: pages } = useQuery({
    queryKey: ["page", pageFilters, pageSearch],
    queryFn: async () => {
      const res = await pageList({
        ...pageFilters,
        parentId: null,
        ...(pageSearch && { keyword: pageSearch }),
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: removeDuplicateFromArray([
            ...(pages?.data || []),
            ...res?.docs?.data,
          ]),
        };
      } else {
        if (pages?.data?.length > 0) {
          return pages;
        } else {
          return res;
        }
      }
    },
  });

  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        featuredImage: data?.featuredImage?.url,
        metaTitle: data?.seo?.metaTitle,
        metaDescription: data?.seo?.metaDescription,
        focusKeyword: data?.seo?.focusKeyword.map((item, index) => ({
          label: item,
          value: index + 1,
        })),
        ogTitle: data?.seo?.ogTitle,
        ogDescription: data?.seo?.ogDescription,
        ogImage: data?.seo?.ogImage?.url,
      });
    }
  }, [data]);

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const {
        metaTitle,
        metaDescription,
        focusKeyword,
        ogTitle,
        ogDescription,
        ogImage,
        ...rest
      } = val;
      const payload = {
        ...rest,
        author: user?._id,
        seo: {
          metaTitle,
          metaDescription,
          focusKeyword: focusKeyword?.map((item) => item?.label),
          ogTitle,
          ogDescription,
          ogImage,
        },
        ...(data?._id && { id: data?._id }),
      };

      return await pageAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        getResponse(res);
        return res;
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="h-full p-4">
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          <div className="relative col-span-8">
            <Input
              label="Page Title"
              inputPlaceholder={"Enter Page Title"}
              inputName="title"
              value={values?.title || ""}
              onChange={handleChange}
              {...formValidate(errors, "title")}
            />
          </div>
          <div className="relative col-span-4">
            <Select
              label={"Select Parent"}
              placeholder="Select Parent Page"
              selectedValue={values?.parentId}
              dropdownData={removeDuplicateFromArray(
                [
                  ...(pages?.data || [])
                    ?.filter((item) => item === data?.parentId)
                    .map((item) => ({
                      name: item?.title,
                      value: item?._id,
                    })),
                  ...(pages?.data || [])
                    ?.filter((item) => item?._id !== data?._id)
                    ?.map((q) => ({
                      name: q?.title,
                      value: q?._id,
                    })),
                ],
                "value"
              )}
              onChange={(val) => {
                handleChange({ target: { name: "parentId", value: val } });
              }}
              onScroll={(e) => {
                loadData(e, pages, setPageFilters);
              }}
              {...formValidate(errors, "parentId")}
            />
          </div>

          <div className="relative col-span-12">
            <FileUploadSingle
              label={"Upload Page Image"}
              labelClasses={"!mb-2"}
              value={values?.featuredImage}
              onChange={(file) =>
                handleChange({ target: { name: "featuredImage", value: file } })
              }
              {...formValidate(errors, "featuredImage")}
            />
          </div>

          <div className="relative col-span-12">
            <Textarea
              label="Excerpt"
              inputPlaceholder={"Enter Excerpt"}
              inputName="excerpt"
              inputValue={values?.excerpt || ""}
              onChange={handleChange}
              {...formValidate(errors, "excerpt")}
            />
          </div>

          <div className="relative col-span-12">
            <Editor
              label="Description"
              value={values?.content}
              onChange={(val) =>
                handleChange({ target: { name: "content", value: val } })
              }
              {...formValidate(errors, "content")}
            />
          </div>

          <div className="relative col-span-12">
            <Input
              label="Template"
              inputPlaceholder={"Enter Template"}
              inputName="template"
              value={values?.template || ""}
              onChange={handleChange}
              {...formValidate(errors, "template")}
            />
          </div>

          <div className="relative col-span-6">
            <Select
              label={"Visibility"}
              placeholder="Select Visibility"
              selectedValue={values?.visibility}
              dropdownData={[
                { name: "Public", value: "public" },
                { name: "Private", value: "private" },
                { name: "Password", value: "password" },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "visibility", value: val } });
              }}
              {...formValidate(errors, "visibility")}
            />
          </div>

          <div className="relative col-span-6">
            <Select
              label={"Status"}
              placeholder="Select status"
              selectedValue={values?.status}
              dropdownData={[
                { name: "Draft", value: "draft" },
                { name: "Published", value: "published" },
                { name: "Private", value: "private" },
                { name: "Trash", value: "trash" },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "status", value: val } });
              }}
              {...formValidate(errors, "status")}
            />
          </div>

          {/* <div className="relative col-span-12 space-y-4">
            <div className="space-y-4">
              {values?.button?.map((item, i) => (
                <div key={i?.toString()} className="flex items-end space-x-4">
                  <div className="flex-shrink flex-grow w-1/2">
                    <Input
                      label={"Button label " + (i + 1)}
                      value={item?.label || ""}
                      inputPlaceholder={"Enter button label"}
                      onChange={(e) => {
                        setFieldsValue({
                          button: values?.button?.map((item, index) =>
                            i === index
                              ? { ...item, label: e.target.value }
                              : item
                          ),
                        });
                      }}
                    />
                  </div>
                  <div className="flex-shrink flex-grow w-1/2">
                    <Input
                      label={"Button link " + (i + 1)}
                      value={item?.link || ""}
                      inputPlaceholder={"Enter button link"}
                      onChange={(e) => {
                        setFieldsValue({
                          button: values?.button?.map((item, index) =>
                            i === index
                              ? { ...item, link: e.target.value }
                              : item
                          ),
                        });
                      }}
                    />
                  </div>
                  <div className="flex-shrink-0 !ml-0">
                    <Button
                      buttonIcon={"fa-regular fa-trash-can"}
                      buttonClasses={"!bg-transparent !text-chestnut-rose"}
                      buttonIconPosition={"left"}
                      buttonFunction={() => {
                        setFieldsValue({
                          button: values?.button?.filter(
                            (item, index) => i !== index
                          ),
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center">
              <Button
                buttonClasses={
                  "!text-chestnut-rose !h-6 !p-0 !rounded-none !bg-transparent"
                }
                buttonLabel={"Add Action"}
                buttonLabelClasses={"!text-sm"}
                buttonFunction={() => buttonGenerateHandler()}
              />
            </div>
          </div> */}

          <div className="relative col-span-12">
            <h4 className="font-semibold text-lg mb-2">SEO Section</h4>
            <div className="grid grid-cols-12 gap-4">
              <div className="relative col-span-6">
                <Input
                  label="Meta Title"
                  inputPlaceholder={"Enter Meta Title"}
                  inputName="metaTitle"
                  value={values?.metaTitle || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "metaTitle")}
                />
              </div>
              <div className="relative col-span-6">
                <Textarea
                  label="Meta Description"
                  inputPlaceholder={"Enter Meta Description"}
                  inputName="metaDescription"
                  inputValue={values?.metaDescription || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "metaDescription")}
                />
              </div>
              <div className="relative col-span-6">
                <Tags
                  label="Keyword"
                  placeholder={"Enter Keyword"}
                  value={values?.focusKeyword}
                  dropdownData={values?.focusKeyword}
                  onChange={(val) => {
                    handleChange({
                      target: { name: "focusKeyword", value: val },
                    });
                  }}
                />
              </div>
              <div className="relative col-span-6">
                <FileUploadSingle
                  label={"Upload OG Image"}
                  labelClasses={"!mb-2"}
                  size="small"
                  value={values?.ogImage}
                  onChange={(file) =>
                    handleChange({ target: { name: "ogImage", value: file } })
                  }
                  {...formValidate(errors, "ogImage")}
                />
              </div>
              <div className="relative col-span-6">
                <Input
                  label="OG Title"
                  inputPlaceholder={"Enter OG Title"}
                  inputName="ogTitle"
                  value={values?.ogTitle || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "ogTitle")}
                />
              </div>
              <div className="relative col-span-6">
                <Textarea
                  label="OG Description"
                  inputPlaceholder={"Enter OG Description"}
                  inputName="ogDescription"
                  inputValue={values?.ogDescription || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "ogDescription")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType="submit"
              buttonLabel={"Save Page"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
            <Button
              buttonLabel={"Cancel"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonFunction={close}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManagePage;
